import { NavigationProp } from '@react-navigation/native';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import type { PropsWithChildren } from 'react';
import { View, Text, Image, useWindowDimensions, ScrollView, Pressable, Linking, Platform, Modal, Alert, Dimensions } from 'react-native';
import HeaderComponent from '../components/headerComponent';
import HeaderStepperComponent from '../components/headerStepperComponent';
import { SafeAreaView } from 'react-native-safe-area-context';
import InputComponent from '../components/inputComponent';
import ButtonComponent, { enumIconButtonComponent, enumTypesButtonComponent } from '../components/buttonComponent';
import SelectDropDowmComponent, { optionsSelectDropDown } from '../components/selectDropDown';
import { enumPages } from '../App';
import { billingOptionsStepperFormModel, billingOptionsStepperItems, billingOptionsStepperModel } from '../models/billingOptionsStepper.model';
import { BillingHomeStyles } from '../styles/billingHomeStyles';
import CardButtonComponent, { enumIconCardButtonComponent } from '../components/cardButtonComponent';
import { GlobalVariables } from '../utils/globalVariables';
import IconWhatsapp from '../source/icons/whatsapp';
import IconQuestion from '../source/icons/question';
import IconClose from '../source/icons/close';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import moment from 'moment';
import ModalLoading from '../components/modalLoading';
import IconWarning from '../source/icons/warning';
import responseVisitaValidar from '../models/response-visita-validar.model';
import responseCFDICatalogoUsoCFDI from '../models/response-cfdi-catalogo-usoCFDI.model';
import responseCFDICatalogoRegimenFiscal from '../models/response-cfdi-catalogo-regimenFiscal.model';
import responseCFDIDocumentosIdNotaFactura from '../models/response-cfdi-documentos-idNotaFactura.model';
import { itemsStepperFormValues } from '../models/itemsStepper-form-values.model';
import { downloadFile } from '../utils/tranformClass';

import ReadProperties from '../utils/comandos.js';
ReadProperties.leerArchivoProps();

//amr import { StyleSheet, Button } from 'react-native';
//amr const stylesamr = StyleSheet.create({
//amr   container: {
//amr     flex: 1,
//amr     justifyContent: 'space-around',
//amr     alignItems: 'center',
//amr   },
//amr });
//amr const createTwoButtonAlert = () =>
//amr Alert.alert('Alert Title', 'My Alert Msg', [
//amr {
//amr   text: 'Cancel',
//amr   onPress: () => console.log('Cancel Pressed'),
//amr   style: 'cancel',
//amr },
//amr {text: 'OK', onPress: () => console.log('OK Pressed')},
//amr ]);

type SectionProps = PropsWithChildren<{
  navigation: NavigationProp<any, any>;
}>;

function BillingHomePage({ navigation }: SectionProps): JSX.Element {
   // +amr
   //amr const queryParams = new URLSearchParams(window.location.search);
   //amr var par = queryParams.get('lab');
   //amr var lab = par ? par : 'POLANCO';
	//amr ReadProperties.leerArchivoProps();
//	var rf = 610;
	var codPos = '00000';
	var lab = GlobalVariables.vars.lab;
	var wur = GlobalVariables.vars.wur;
	//amr-1 var wur = 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0';
	//amr-1 var wur = 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0';
   if (lab.toUpperCase() === 'POLANCO') {
		lab = lab.toUpperCase();
		wur = 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0';
   } else {
      if (lab.toUpperCase() === 'RUIZ') {
			lab = lab.toUpperCase();
			wur = 'https://api.whatsapp.com/send?phone=5215580466180&text=Hola&type=phone_number&app_absent=0';
      } else {
			lab = 'POLANCO';
			wur = 'https://api.whatsapp.com/send?phone=5215580466181&text=Hola&type=phone_number&app_absent=0';
      }
   }
   // +amr

  const styles = BillingHomeStyles();
  const layout = useWindowDimensions();
  const stylesGeneral = GlobalVariables.class(layout);
  //Obtiene el elemento scrollview
  const scrollRef = useRef<null | ScrollView>(null);
  //Guarda los stepper a visualizar para la informacion del usuario;
  const [itemsStepper, setItemsStepper] = useState(billingOptionsStepperItems(styles));
  //Guarda la clonacion stepper de la informacion del usuario;
  const [cloneObjects] = useState({ itemsStepper: billingOptionsStepperItems(styles), formValues: itemsStepperFormValues });
  //Guarda el index stepper actual de la vista del usuario;
  const [indexStepShow, setIndexStepShow] = useState(0);
  //Guarda el estado de si ya esta listo la descarga con la informacion guardada en el fomulario
  const [showBillDownload, setShowBillDownload] = useState(false);
  //Guuarda el estado onhover por cada icono de pregunta
  const [onHoverQuestion, setOnHoverQuestion] = useState('');
  //Guarda el estado de icono ayuda en datos personales
  const [visibleHelp, setVisibleHelp] = useState({ show: false, visible: '' });
  //Guarda el estado de datos incorrectos en datos personales
  const [visibleErrorAlert, setVisibleErrorAlert] = useState({ text: '', visible: false });
  //Guarda el estado habilitar del boton siguiente en el formulario
  const [disabledNext, setDisabledNext] = useState(false);
  //Guarda el token del usuario
  const [tokenUser, setTokenUser] = useState('');
  //Guarda las options del select de cfdi
  const [optionsCFDI, setOptionsCFDI] = useState<optionsSelectDropDown[]>([]);
  //Guarda las options del select de regimen fiscal
  const [optionsRegimenFiscal, setOptionsRegimenFiscal] = useState<optionsSelectDropDown[]>([]);
  //Guarda el estado para no repetir llamado de servicio de options
  const [finishOptions, setFinishOptions] = useState(false);
  //Guarda el id data del envio de visita
  const [responseVisit, setResponseVisit] = useState<responseVisitaValidar>(new responseVisitaValidar());
  //Guarda el estatus de la vista de la modal loading
  const [loading, setLoading] = useState(false);
  //Guarda el estado de si ya se mando a traer estados y municipios cuando ingreso codigo postal
  const [estadoMunicipioReady, setEstadoMunicipioReady] = useState(false);
  //Guarda la respuesta de los documentos a descargar de la factura
  const [responseTaxPdf, setResponseTaxPdf] = useState<responseCFDIDocumentosIdNotaFactura>(new responseCFDIDocumentosIdNotaFactura());
  //Guarda los valores del formulario
  const [formValues, setFormValues] = useState<any>(itemsStepperFormValues);
  //-> Resetea los valores de facturacion
  const resetAll = useCallback(() => {
    setIndexStepShow(0);
    setOptionsCFDI([]);
    setOptionsRegimenFiscal([]);
    setFinishOptions(false);
    scrollToTop();
//amr scrollToBottom();
//amr createTwoButtonAlert();
    setEstadoMunicipioReady(false);
    setItemsStepper(cloneObjects.itemsStepper);
    setFormValues(cloneObjects.formValues);
    setVisibleErrorAlert({ text: '', visible: false });
    setShowBillDownload(false);
  }, [cloneObjects]);
  //-> Listener que detecta cuando salimos de facturacion
  useEffect(()=>{
    navigation.addListener('blur',(page)=>{
      let cPage = page.target?.split('-')[0];
      if (cPage === enumPages.facturacion) {
        resetAll();
		}
    });
  }, [navigation, resetAll]);
  //-> Detecta si cambio algo de los campos del formulario
  useEffect(() => {
    let disabled = false;
    for (let k of Object.keys(formValues[indexStepShow])) {
      if (!formValues[indexStepShow][k]) {
        //-> campo extension no es obligatorio
        if (k !== 'calle' && k !== 'numeroExterior' && k !== 'numeroInterior'
				&& k !== 'colonia' && k !== 'municipio' && k !== 'estado'
					&&  k !== 'telefono' && k !== 'extension') {
          disabled = true;
          break;
        }
      }
    }
    setDisabledNext(disabled);
  }, [formValues, indexStepShow]);
  useEffect(() => {
    //Obtiene el token del usuario, guardado previamente
    const getAuthToken = async () => {
      return await AsyncStorage.getItem(GlobalVariables.localStorage.token);
    };
    //Ejecución del metodo para obtener el token, guardado previamente
    getAuthToken().then((token: any) => {
      if (token) {
        setTokenUser(token);
      }
    });
  }, []);
  useEffect(() => {
    //-> Cuanto terminen de cargar todos los servicios que rellenan los dropdown de datos fiscales
    if (optionsCFDI.length > 0 && optionsRegimenFiscal.length > 0 && !finishOptions) {
      let obj: billingOptionsStepperModel[] = [...itemsStepper];
      obj[1].form.forEach((element) => {
//amr        if (element.id === 'usoCFDI') {
//amr          element.options = optionsCFDI;
//amr        }
        if (element.id === 'regimenFiscal') {
          element.options = optionsRegimenFiscal;
        }
      });
      setLoading(false);
      setItemsStepper(obj);
      setFinishOptions(true);
    }
  }, [optionsCFDI, optionsRegimenFiscal, itemsStepper, finishOptions]);
  useEffect(() => {
    if (finishOptions) {
      setTimeout(() => {
        scrollToTop();
      }, 500);
    }
  }, [finishOptions]);
	const changeValueForm = (key: string, value: any) => {
//amr	let newValue = !value || parseInt(value) === 0 ? '' : value;
		let newValue = !value || Number(value) === 0 ? '' : value;
		switch (key) {
			case 'codigoPostal':
				if (GlobalVariables.patterns.zipCode.test(newValue)) {
					sendZipCode(tokenUser, newValue);
codPos = newValue;
console.log('codigoPostal=> ' + codPos);
				} else {
					if (estadoMunicipioReady) {
						resetEstadoMunicipio();
					}
				}
				break;
			case 'fechaVisita':
				newValue = `${moment(newValue).format('DD/MM/YYYY')} 12:00:00`;
				break;
			case 'regimenFiscal':
			case 'usoCFDI':
				let array = key === 'regimenFiscal' ? optionsRegimenFiscal : optionsCFDI;
				let find = array.find(e => e.value === newValue);
				newValue = {
					claveSat: find?.value,
					descripcion: find?.label,
				};
				if (key === 'regimenFiscal') {
					setOptionsCFDI([]);
					let rf = Number(find?.value);
console.log('regimenFiscal=> ' + rf);
					getCFDI(tokenUser, rf);
				}
				break;
			case 'colonia':
				newValue = {
					id: null,
					claveSat: null,
					nombre: newValue,
				};
				break;
		}
		setFormValues((prevState: any) => ({
			...prevState,
			[indexStepShow]: {
				...prevState[indexStepShow],
				[key]: newValue,
			},
		}));
	};
	//-> Guarda el token del usuario recibido del servicio
	const setTokenAuth = (reload: string, data: any) => {
		axios.post(`${GlobalVariables.vars.api}PortalServicios/login`, GlobalVariables.vars.dataTokenUser, {
			headers: {
				'Content-Type': 'application/json',
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			let token = response.data;
			async function setAuthToken() {
				return await AsyncStorage.setItem(GlobalVariables.localStorage.token, token);
			}
			setAuthToken().then(() => {
				setTokenUser(token);
				switch (reload) {
					case 'sendDataVisit':
						sendDataVisit(token, data);
						break;
					case 'getCFDI':
						getCFDI(token, data);
						break;
					case 'sendZipCode':
						sendZipCode(token, data);
						break;
					case 'sendTaxData':
						sendTaxData(token, data);
						break;
					case 'getRegimenFiscal':
						getRegimenFiscal(token, data);
						break;
					case 'getTaxPdf':
						getTaxPdf(token, data);
						break;
				}
			});
		}).catch(function (error) {
			console.log(error);
		});
	};
	//-> Metodo que envia los datos de visita
	const sendDataVisit = (myToken: string, data: any) => {
		let url = `${GlobalVariables.vars.api}PortalServicios/api/visita/validar`;
//amr	data.data.expediente = parseInt(data.data.expediente);
//amr	data.data.numeroVisita = parseInt(data.data.numeroVisita);
		data.data.expediente = Number(data.data.expediente);
		data.data.numeroVisita = Number(data.data.numeroVisita);
		axios.post(url, data.data, {
			headers: {
				'Authorization': myToken,
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			if (response.status === 200) {
				let visita: responseVisitaValidar = response.data;
				setResponseVisit(visita);
				if (!response.data) {
					setLoading(false);
					setVisibleErrorAlert({ text: 'Datos incorrectos de la visita', visible: true });
					setTimeout(() => {
						scrollToTop();
					}, 500);
				} else {
					//Si queremos solo volver a traer el id, solo aplica cuando se rellena datos de facturacion y queremos descargar archivo
					if (data.response.revalidate) {
						let obj = {form: formValues[indexStepShow], id: visita.facturasNota[0].idFacturaNota};
						sendTaxData(tokenUser, obj);
					} else {
						setVisibleErrorAlert({ text: '', visible: false });
						if (visita.facturada) {
							getTaxPdf(myToken, { formValues: formValues[0], visita: visita });
						} else {
							setIndexStepShow(data.index);
							//amr getCFDI(myToken, {});
							getCFDI(myToken, 11);
setOptionsCFDI([]);
						}
					}
				}
			}
		}).catch(function (error) {
			if (error?.response?.data === 'Unauthorized') {
				setTokenAuth('sendDataVisit', data);
			} else {
				setLoading(false);
				Alert.alert('Problemas tecnicos', JSON.stringify(error));
			}
		});
	};
	//-> Metodo que obtiene los cfdis dinamicamente
//amr	const getCFDI = (myToken: string, data: any) => {
	const getCFDI = (myToken: string, data: number) => {
		let url = `${GlobalVariables.vars.api}PortalServicios/api/cfdi/catalogo/usoCFDIs/${data}`;
		axios.get(url, {
			headers: {
				'Authorization': myToken,
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			if (response.status === 200) {
console.log('getCFDI => ' + `${data}`);
				let cfdi: responseCFDICatalogoUsoCFDI[] = response.data;
				let options: optionsSelectDropDown[] = [];
				cfdi.forEach((element: responseCFDICatalogoUsoCFDI) => {
console.log('claveSat => ' + element.claveSat);
					options.push({
						value: element.claveSat,
						label: element.descripcion,
					});
				});

				let obj: billingOptionsStepperModel[] = [...itemsStepper];
				obj[1].form.forEach((element) => {
					if (element.id === 'usoCFDI') {
				//amr	element.options = optionsCFDI;
						element.options = options;
					}
				});
				setLoading(false);

				setOptionsCFDI(options);
				getRegimenFiscal(myToken, {});
			}
		}).catch(function (error) {
			if (error?.response?.data === 'Unauthorized') {
				setTokenAuth('getCFDI', data);
			} else {
				setLoading(false);
				Alert.alert('Problemas tecnicos', 'Intenta mas tarde');
			}
		});
	};
	//-> Metodo que obtiene los regimen fiscales disponibles
	const getRegimenFiscal = (myToken: string, data: any) => {
		let url = `${GlobalVariables.vars.api}PortalServicios/api/cfdi/catalogo/regimenFiscal`;
		axios.get(url, {
			headers: {
				'Authorization': myToken,
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			if (response.status === 200) {
				let fiscal: responseCFDICatalogoRegimenFiscal[] = response.data;
				let options: optionsSelectDropDown[] = [];
				fiscal.forEach((element: responseCFDICatalogoRegimenFiscal) => {
					options.push({
						value: element.claveSat,
						label: element.descripcion,
					});
				});
				setOptionsRegimenFiscal(options);
			}
		}).catch(function (error) {
			if (error?.response?.data === 'Unauthorized') {
				setTokenAuth('getRegimenFiscal', data);
			} else {
				setLoading(false);
				Alert.alert('Problemas tecnicos', 'Intenta mas tarde');
			}
		});
	};
	//-> Metodo que envia el codigo postal ingresado e inserta municio y estado
	const sendZipCode = (myToken: string, data: any) => {
		setLoading(true);
		let url = `${GlobalVariables.vars.api}PortalServicios/api/codigoPostal/${data}`;
		axios.get(url, {
			headers: {
				'Authorization': myToken,
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			if (response.status === 200) {
				let obj: billingOptionsStepperModel[] = [...itemsStepper];
console.log('response.data.municipio => ' + response.data[0].municipio.nombre);
console.log('response.data.estado    => ' + response.data[0].estado.nombre);
console.log('response.data.pais      => ' + response.data[0].pais.nombre);
				obj[1].form.forEach((element) => {
					if (element.id === 'estado') {
						element.options = [{
							label: response.data[0].estado.nombre,
							value: response.data[0].estado.id,
						}];
						element.selected = 0;
						element.value = response.data[0].estado.nombre;
					}
					if (element.id === 'municipio') {
						element.value = response.data[0].municipio.nombre;
					}
				});
				setFormValues({
					...formValues,
					[indexStepShow]: {
						...formValues[indexStepShow],
						estado: response.data[0].estado,
						pais: response.data[0].pais,
						municipio: response.data[0].municipio,
						codigoPostal: data,
					},
				});
				setEstadoMunicipioReady(true);
				setVisibleErrorAlert({ text: '', visible: false });
				setLoading(false);
				setItemsStepper(obj);
			}
		}).catch(function (error) {
			if (error?.response?.data === 'Unauthorized') {
				setTokenAuth('sendZipCode', data);
			} else {
				if (error?.response?.status === 500) {
//amr					setLoading(false);
//amr					setEstadoMunicipioReady(false);
//amr					resetEstadoMunicipio();
//amr					setVisibleErrorAlert({ text: 'El código postal es incorrecto', visible: true });
//amr					setTimeout(() => {
//amr						scrollToTop();
//amr					}, 500);

					let obj: billingOptionsStepperModel[] = [...itemsStepper];
					obj[1].form.forEach((element) => {
						if (element.id === 'estado') {
							element.options = [{
								label: '--',
								value: 35,
							}];
							element.selected = 0;
							element.value = '--';
						}
						if (element.id === 'municipio') {
							element.value = '--';
						}
					});
					setFormValues({
						...formValues,
						[indexStepShow]: {
							...formValues[indexStepShow],
//							estado: { id:9, claveSat:'MX', nombre:'Ciudad de Mexico' },
							estado: { id:1, claveSat:'MX', nombre:'--' },
							pais: { claveSat:'MX', nombre:'México (Estados Unidos Mexicanos)' },
//							municipio: { id:9, claveSat:'MX', nombre:'Gustavo A. Madero' },
							municipio: { id:1, claveSat:'MX', nombre:'--' },
							codigoPostal: codPos,
						},
					});
					setEstadoMunicipioReady(true);
					setVisibleErrorAlert({ text: '', visible: false });
					setLoading(false);
					setItemsStepper(obj);

				} else {
					setLoading(false);
					Alert.alert('Problemas tecnicos', 'Intenta mas tarde');
				}
			}
		});
	};
	//-> Metodo que envia los datos de facturacion para timbrar
	const sendTaxData = (myToken: string, data: any) => {
		let url = `${GlobalVariables.vars.api}PortalServicios/api/cfdi/timbrar/${data.id}`;
		axios.post(url, data.form, {
			headers: {
				'Authorization': myToken,
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			if (response.status === 200) {
				let visita: responseVisitaValidar = response.data;
				setResponseVisit(visita);
				getTaxPdf(myToken, { formValues: formValues[0], visita: visita });
			}
		}).catch(function (error) {
			if (error?.response?.data === 'Unauthorized') {
				setTokenAuth('sendTaxData', data);
			} else {
				if (error?.response?.status === 500) {
					setLoading(false);
					let msg = error.response.data || 'No se pudo generar tu factura electrónica, favor de acudir a alguna de nuestras sucursales';
/* -amr
					let rsp = error.response.data;
					console.log('rsp=> ' + rsp.substring(0,2));
					let msg = rsp.substring(0,2) === 'No' ? rsp : rsp.substring(0,15) + ' En caso de requerir refacturación por datos fiscales, debe acudir a la sucursal donde se realizó el pago; si su pago fue mediante call center comunicarse al 55 50 80 19 10.';
					console.log('msg=> ' + msg);
-amr */
					setVisibleErrorAlert({ text: msg, visible: true });
					setTimeout(() => {
						scrollToTop();
					}, 700);
				} else {
					setLoading(false);
					Alert.alert('Problemas tecnicos', 'Intenta mas tarde');
				}
			}
		});
	};
	//-> Metodo que obtiene los documentos XML y PDF de datos timbrados
	const getTaxPdf = (myToken: string, data: any) => {
		let url = `${GlobalVariables.vars.api}PortalServicios/api/cfdi/documentos/${data.visita.facturasNota[0].idFacturaNota}`;
		axios.post(url, data.formValues, {
			headers: {
				'Authorization': myToken,
				'ngrok-skip-browser-warning': '69085',
			},
		}).then(function (response) {
			if (response.status === 200) {
				setResponseTaxPdf(response.data);
				setShowBillDownload(true);
				setVisibleErrorAlert({ text: '', visible: false });
				setLoading(false);
				scrollToTop();
			}
		}).catch(function (error) {
			if (error?.response?.data === 'Unauthorized') {
				setTokenAuth('getTaxPdf', data);
			} else {
				setLoading(false);
				Alert.alert('Problemas tecnicos', 'Intenta mas tarde');
			}
		});
	};
	//-> Metodo que obtiene el click de los botones Volver y Siguiente para asignar la vista correspondiente de stepper
  const changeStepper = (event: any) => {
    let index = event.type === 'back-stepper' ?
      event.index :
      event === 'next' ?
        indexStepShow + 1 : indexStepShow - 1;
    //-> Validamos que no se pase de pantalla stepper
    if (index < itemsStepper.length && index >= 0) {
      //-> Pasamos de datos personales a facturación
      if (indexStepShow === 0 && index === 1) {
        setLoading(true);
        let obj = { index: index, data: formValues[indexStepShow], response: {} };
        sendDataVisit(tokenUser, obj);
      }
      //-> Regresamos de datos de facturacion a personales
      if (indexStepShow === 1 && index === 0) {
        resetAll();
      }
    }
    //Lo mandamos a pantalla home ya que no existe el stepper index -1
    if (index < 0) {
		navigation.navigate(enumPages.inicio);
		//amr navigation.navigate(enumPages.inicio, {lab});
    }
    //Lo mandamos a la seccion de descargar factura y enviamos datos de facturación
    if (index >= itemsStepper.length) {
      setLoading(true);
      let obj = { index: index, data: formValues[0], response: {revalidate:true} };
      sendDataVisit(tokenUser, obj);
    }
  };
  const scrollToTop = () => {
    scrollRef.current?.scrollTo({
      y: 0,
      animated: true,
    });
  };
//amr  const scrollToBottom = () => {
//amr    scrollRef.current?.scrollTo({
//amr      y: 20,
//amr      animated: true,
//amr    });
//amr  };
  const toggleOpenHelp = (e: any, open: boolean) => {
    setVisibleHelp({ show: open, visible: e.question || '' });
  };
  const resetEstadoMunicipio = () => {
    setFormValues({
      ...formValues,
      [indexStepShow]: {
        ...formValues[indexStepShow],
        estado: '',
        pais: '',
        municipio: '',
      },
    });
    let obj: billingOptionsStepperModel[] = [...itemsStepper];
    obj[1].form.forEach((element) => {
      if (element.id === 'estado') {
        element.options = [];
        element.selected = -1;
      }
      if (element.id === 'municipio') {
        element.value = '';
      }
    });
    setItemsStepper(obj);
  };
  //Metodo que renderiza los stepper a visualizar
  const renderGroupStepper = () => {
console.log('indexStepShow=> ' + indexStepShow);
	let txtMsg = (indexStepShow !== 0) ? '' : '**Aunque la cantidad sea entera coloque los decimales.';
    return (
      <>
        <Text style={styles('title')}>Facturación</Text>
        <Text style={styles('subtitle')}>¡Bienvenido/a al portal de facturación! Nuestro portal te permitirá generar tus facturas electrónicas de manera rápida y segura.</Text>
        <View style={styles('containterSteps')}>
          <HeaderStepperComponent
            indexStepShow={indexStepShow}
            items={itemsStepper}
            onPress={(event: any) => {
              event.type = 'back-stepper';
              changeStepper(event);
            }}
          />
          <SafeAreaView style = {{ marginTop: 10 }}>
            <View style={[styles('groupStep')]}>
              {
                itemsStepper[indexStepShow].form.map((element: billingOptionsStepperFormModel, indexForm: number) => (
                  element.rowGroup ?
                    <View style={[
                      styles('itemGroupStep'),
                      indexStepShow === 1 && styles('inputExtraLarge'),
                      element.style,
                    ]} key={`${indexStepShow}-${indexForm}-form`}>
                      {
                        element.rowGroup.map((sameGroup: billingOptionsStepperFormModel, indexSG: number) => {
                          return (
                            <View style={[
                                { marginRight: 10 },
                                element.style,
                                sameGroup.id === 'calle' && styles('calle'),
                                sameGroup.id === 'numeroExterior' && styles('numeroExterior'),
                                sameGroup.id === 'numeroInterior' && styles('numeroInterior'),
                                sameGroup.id === 'colonia' && styles('colonia'),
                                sameGroup.id === 'municipio' && styles('municipio'),
                                sameGroup.id === 'estado' && styles('estado'),
                                sameGroup.id === 'telefono' && styles('telefono'),
                                sameGroup.id === 'extension' && {marginRight: 0},
                              ]} key={`${indexSG}-sm`}>
                              {
                                sameGroup.icon ? sameGroup.icon : null
                              }
                              {
                                sameGroup.dropdown ?
                                  <SelectDropDowmComponent
                                    required={true}
                                    title={sameGroup.title}
                                    placeholder={sameGroup.placeholder}
                                    options={sameGroup.options}
                                    maxHeight={sameGroup.maxHeight}
                                    disabled={sameGroup.disabled}
                                    selected={sameGroup.selected}
                                    withFilter={sameGroup.withFilter}
                                    style={[
                                      styles('inputComponent'),
                                      indexStepShow === 1 && sameGroup.dropdownLarge && styles('inputExtraLarge'),
                                      sameGroup.style,
                                    ]}
                                    onChange={(value: any) => changeValueForm(sameGroup.id, value)}
                                    dropdownLarge={sameGroup.dropdownLarge}
                                  />
                                  :
                                  <InputComponent
                                    style={[
                                      styles('inputGroup'),
                                      indexStepShow === 1 && sameGroup.buttonLarge && styles('inputExtraLarge'),
                                      indexStepShow === 1 && sameGroup.buttonSmall && styles('inputExtraSmall'),
                                      sameGroup.style,
                                    ]}
                                    required={sameGroup.required === false ? false : true}
                                    title={sameGroup.title}
                                    disabled={sameGroup.disabled}
                                    value={sameGroup.value}
                                    buttonLarge={sameGroup.buttonLarge}
                                    placeHolder={sameGroup.placeholder}
                                    maxLength={sameGroup.maxLength}
                                    onInput={(value: any) => changeValueForm(sameGroup.id, value)}
                                    type={sameGroup.type} />
                              }
                            </View>
                          );
                        })
                      }
                    </View>
                    :
                    <View style={[
                      styles('itemGroupStep'), indexStepShow === 1 && styles('inputExtraLarge'),
                      element.style]} key={`${indexStepShow}-${indexForm}-form`}>
                      {
                        element.icon ? element.icon : null
                      }
                      {
                        element.dropdown ?
                          <SelectDropDowmComponent
                            required={true}
                            title={element.title}
                            placeholder={element.placeholder}
                            options={element.options}
                            maxHeight={element.maxHeight}
                            disabled={element.disabled}
                            selected={element.selected}
                            withFilter={element.withFilter}
                            style={[
                              styles('inputComponent'),
                              indexStepShow === 1 && element.dropdownLarge && styles('inputExtraLarge'),
                            ]}
                            dropdownLarge={element.dropdownLarge}
                            onChange={(value: any) => changeValueForm(element.id, value)}
                          />
                          :
                          <>
                            <InputComponent
                              style={[
                                styles('inputComponent'),
                                indexStepShow === 1 && element.buttonLarge && styles('inputExtraLarge'),
                              ]}
                              required={true}
                              value={element.value}
                              disabled={element.disabled}
                              buttonLarge={element.buttonLarge}
                              title={element.title}
                              placeHolder={element.placeholder}
                              type={element.type}
                              upperCase={element.upperCase}
                              maxLength={element.maxLength}
                              onInput={(value: any) => changeValueForm(element.id, value)} />
                            {
                              element.question ?
                                <Pressable
                                  style={styles('pressableQuestion')}
                                  onHoverIn={() => setOnHoverQuestion(element.title || '')}
                                  onHoverOut={() => setOnHoverQuestion('')}
                                  onPress={() => toggleOpenHelp(element, true)}>
                                  <IconQuestion
                                    fill={element.title === onHoverQuestion ? GlobalVariables.colors.primary.textColorBlue : GlobalVariables.colors.secondary.brightBlue} />
                                </Pressable>
                                : null
                            }
                          </>
                      }
                    </View>
                )
                )
              }
<Text style={styles('subtitle')}>{txtMsg}</Text>
            </View>

{/* -amr
<View style={stylesamr.container}>
	<Button title={'Button Alert'} onPress={createTwoButtonAlert} />
</View>
-amr */}

          </SafeAreaView>
        </View>
        <View style={styles('containerButtons')}>
          <ButtonComponent
            type={enumTypesButtonComponent.secondaryButton}
            text="Volver"
            icon={enumIconButtonComponent.arrowBack}
            style={[styles('buttons'), {
              flexDirection: 'row-reverse',
            }]
            }
            onPressButton={() => { changeStepper('back'); }} />
          <ButtonComponent
            type={enumTypesButtonComponent.auxiliarButton}
            text="Siguiente"
            icon={enumIconButtonComponent.arrowNext}
            style={[styles('buttons')]}
            disabled={disabledNext}
            onPressButton={() => {
              changeStepper('next');
            }} />
        </View>
      </>
    );
  };
  //Metodo que renderiza la opcion de descargar la factura una vez pasador los stepper de informacion formulario
  const renderDownloadBill = () => {
    return (
      <>
        <View style={{ marginBottom: 30 }}>
          <Image
            style={styles('iconConfirmCircle')}
            source={require('../source/icons/confirmacion.png')} />
        </View>
        <Text style={[styles('subtitle'), styles('subtitleDownload')]}>
          {
            (responseVisit.facturada) ? `Se obtuvo la factura ${responseTaxPdf.folio}`
            : `La factura ${responseTaxPdf.folio}`}
        </Text>
        <Text style={[styles('subtitle'), styles('subtitleDownload')]}>
          {
            (responseVisit.facturada) ? 'satisfactoriamente.'
            : 'ha sido generada satisfactoriamente.'
          }
        </Text>
        <View style={styles('actionsDownload')}>
          <CardButtonComponent
            typeButton={enumTypesButtonComponent.primaryButton}
            icon={enumIconCardButtonComponent.pdf}
            styleContent={[styles('actionsLeftDownload')]}
            textButton="Descargar"
            styleIcon={styles('iconCard')}
            styleButton={styles('buttonDownload')}
            iconButton={enumIconButtonComponent.download}
            onPressButton={() => downloadFile('pdf', responseTaxPdf)}
            onPressIcon={() => downloadFile('pdf', responseTaxPdf)}
          />
          <CardButtonComponent
            typeButton={enumTypesButtonComponent.secondaryButton}
            icon={enumIconCardButtonComponent.xml}
            textButton="Descargar"
            styleIcon={styles('iconCard')}
            styleButton={styles('buttonDownload')}
            iconButton={enumIconButtonComponent.download}
            onPressButton={() => downloadFile('xml', responseTaxPdf)}
            onPressIcon={() => downloadFile('xml', responseTaxPdf)}
          />
        </View>
        {/* -amr <Text style={styles('legend')}>De requerir refacturación, favor de acudir a algunas de nuestras sucursales.</Text> -amr */}
        <Text style={styles('legend')}>En caso de requerir refacturación por datos fiscales, debe acudir a la sucursal donde se realizó el pago; si su pago fue mediante call center comunicarse al 55 50 80 19 10.</Text>
        <Text
          style={[stylesGeneral('primaryLink'), { marginTop: 30 }]}
          onPress={() => {
            navigation.navigate(enumPages.inicio);
				//amr navigation.navigate(enumPages.inicio, {lab});
          }}
        >Volver a menu principal</Text>
      </>
    );
  };
  return (
    <View style={stylesGeneral('generalContainer')}>
      <ScrollView automaticallyAdjustKeyboardInsets={true} ref={scrollRef}>
        <HeaderComponent navigation={navigation} />
        <View style={[styles('container'), {
          paddingTop: visibleErrorAlert.visible ? 100 : 40,
        }]}>
          {
            showBillDownload ? renderDownloadBill() : renderGroupStepper()
          }
          {
            visibleErrorAlert.visible ?
              <View style={[styles('errorPersonales'), {width: Platform.OS === 'android' ? Dimensions.get('window').width : '100%'}]}>
                <IconWarning />
                <Text style={styles('errorPersonalesText')}>{visibleErrorAlert.text}</Text>
              </View>
              : null
          }
        </View>
      </ScrollView>
      <Pressable style={stylesGeneral('iconWhatsapp')} onPress={() => {
        /* -amr let url = GlobalVariables.vars.whatsappLink; -amr */
        let url = wur;
        if (Platform.OS === 'web') {
          window.open(url, '_blank');
        } else {
          Linking.openURL(url);
        }
      }}>
        <IconWhatsapp />
      </Pressable>
      <Modal
        onDismiss={() => toggleOpenHelp({}, false)}
        transparent={true}
        visible={visibleHelp.show}>
        <View style={styles('modal')}>
          <View style={styles('modalContent')}>
            <Pressable style={styles('pressableModalContent')}
              onPress={() => {
                toggleOpenHelp({}, false);
              }}>
              <IconClose fill={GlobalVariables.colors.primary.darkGrey} />
            </Pressable>
            {
				//amr-1 expediente/expediente-ruiz && visita/visita-ruiz
				(visibleHelp.visible === 'expediente') ?
					<Image style={styles('imageHelp')} source={require('../source/image/ejemplo-expediente-ruiz.png')} />
				: (visibleHelp.visible === 'noVisita') ?
					<Image style={styles('imageHelp')} source={require('../source/image/ejemplo-visita-ruiz.png')} />
				: (visibleHelp.visible === 'razonSocial') ?
					<Image style={styles('imageHelp')} source={require('../source/image/razon-social.png')} />
				: (visibleHelp.visible === 'rfc') ?
					<Image style={styles('imageHelp')} source={require('../source/image/rfc.png')} />
				: (visibleHelp.visible === 'regimenFiscal') ?
					<Image style={styles('imageHelp')} source={require('../source/image/regimen-fiscal.png')} />
				: <Image style={styles('imageHelp')} source={require('../source/image/codigo-postal.png')} />
            }
          </View>
        </View>
      </Modal>
      <ModalLoading visible={loading} />
    </View>
  );
}
export default BillingHomePage;
